// Easy Arrival meal choices — flat $350 dinner that feeds 6 to 8
// Customer picks ONE of these meals when reserving an Easy Arrival package.

export const EASY_ARRIVAL_MEALS = [
    {
        id: "mojo-chicken",
        name: "Mojo Grilled Chicken",
        protein: "Chicken",
        tags: [],
        items: [
            "Zesty lime, garlic & cilantro marinated chicken thighs grilled and served with mojo sauce",
            "Black beans & rice",
            "Sweet plantains",
            "Josephine's Greens locally-grown salad",
            "Key lime pie with fresh whipped cream",
        ],
    },
    {
        id: "italian-lasagna",
        name: "Italian Lasagna Dinner",
        protein: "Beef + Pork",
        tags: [],
        items: [
            "Layers of fresh pasta, homemade marinara, sweet Italian sausage, mama's meatballs, ricotta and mozzarella cheese",
            "Local organic Josephine's Greens salad with balsamic vinaigrette",
            "Garlic bread",
            "Key lime pie with fresh whipped cream",
        ],
    },
    {
        id: "chicken-piccata",
        name: "Chicken Piccata Dinner",
        protein: "Chicken",
        tags: [],
        items: [
            "Lightly floured chicken breasts sautéed with white wine, lemon, caper butter sauce",
            "Jasmine rice",
            "Garlic-seared broccoli",
            "Fresh-baked dinner rolls",
            "Key lime pie with fresh whipped cream",
        ],
    },
    {
        id: "veg-pad-thai",
        name: "Vegetable Pad Thai Dinner",
        protein: "Vegan",
        tags: ["GF", "Vegan"],
        items: [
            "Stir-fried rice noodles in a savory sweet & sour sauce with tons of veggies, chopped peanuts, cilantro",
            "Ginger sesame slaw",
            "Mango berry crumble with fresh whipped cream",
        ],
    },
    {
        id: "jerk-pork",
        name: "Jerked Pork Tenderloin",
        protein: "Pork",
        tags: [],
        items: [
            "Marinated and grilled tender pork loin accompanied by a homemade mango chutney",
            "Jasmine rice",
            "Sautéed mixed veggies",
            "Key lime pie with fresh whipped cream",
        ],
    },
    {
        id: "tuscan-chicken",
        name: "Tuscan Chicken Florentine",
        protein: "Chicken",
        tags: [],
        items: [
            "Sautéed chicken breast with a light Parmesan cream, baby spinach and grape tomatoes",
            "Pasta with Alfredo or garlic olio",
            "Roasted veggies",
            "Guava cream pie",
        ],
    },
    {
        id: "enchilada-bake",
        name: "Black Bean & Corn Enchilada Bake",
        protein: "Veggie or Chicken",
        tags: ["Choice of veg or chicken"],
        items: [
            "Layers of corn tortillas, black bean and corn salad, jalapeño crema, Monterey Jack & cheddar cheese, enchilada sauce — your choice of mixed veggies or shredded chicken",
            "Local organic Josephine's Greens salad with housemade ranch dressing",
            "Key lime pie with fresh whipped cream",
        ],
    },
    {
        id: "herb-roasted-chicken",
        name: "Herb Roasted Chicken Dinner",
        protein: "Chicken",
        tags: [],
        items: [
            "Whole roasted organic chicken with fresh herbs and lemon",
            "Homestyle mashed potatoes with gravy",
            "Garlic-seared broccoli",
            "Fresh-baked dinner rolls",
            "Key lime pie with fresh whipped cream",
        ],
    },
    {
        id: "white-lasagna",
        name: "Spinach & Mushroom White Lasagna",
        protein: "Vegetarian",
        tags: ["Vegetarian"],
        items: [
            "Layers of fresh pasta with sautéed garlic spinach and mushrooms, béchamel sauce, ricotta and mozzarella cheese",
            "Local organic Josephine's Greens salad with balsamic vinaigrette",
            "Garlic bread",
            "Key lime pie with fresh whipped cream",
        ],
    },
];

export const getEasyArrivalMeal = (id) =>
    EASY_ARRIVAL_MEALS.find((m) => m.id === id) || null;
